// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module__wrapper___1Im3g","continueShoppingCol":"styles-module__continueShoppingCol___3xvxJ"};